"use client";

import ImageCarousel from "./ImageCarousel";
import SectionTitleBadge from "./SectionTitleBadge";
import { sectionFor, type HomepageProps } from "./types";
import { CarouselSkeleton, useLazyAssets } from "./useLazyAssets";

export default function PartnersCarouselSection({ data }: HomepageProps) {
  const section = sectionFor(data, "partners");
  const logos = useLazyAssets("partner_logo,school_logo");

  // Nothing uploaded from the admin dashboard yet: collapse the section entirely.
  if (logos && logos.length === 0) return null;

  return (
    <section className="bg-white px-6 py-24 lg:px-10">
      <SectionTitleBadge>{section.title || "Our Partners"}</SectionTitleBadge>
      <div className="mx-auto mt-20 max-w-6xl">
        {logos === null ? (
          <CarouselSkeleton frameClassName="aspect-[5/2]" />
        ) : (
          <ImageCarousel
            images={logos}
            visibleCount={3}
            fit="contain"
            frameClassName="aspect-[5/2] bg-white"
            autoPlayInterval={2600}
          />
        )}
      </div>
    </section>
  );
}
